/**
 * Межа помилок лінивого блока з повтором: чанк не завантажився (стара вкладка після релізу, обрив
 * мережі) чи компонент упав — ламається лише цей блок, а не весь екран (рев'ю Frontend #193,
 * Should 1). `fallback` отримує `retry`: він скидає межу, а викликач має дати новий `lazy()`,
 * бо React кешує відхилений імпорт.
 */
import { Component, type ReactNode } from 'react';

interface Props {
  fallback: (retry: () => void) => ReactNode;
  onRetry?: () => void;
  children: ReactNode;
}

export class RetryBoundary extends Component<Props, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  retry = () => {
    this.props.onRetry?.();
    this.setState({ failed: false });
  };
  override render() {
    return this.state.failed ? this.props.fallback(this.retry) : this.props.children;
  }
}
